import styled, { css } from 'styled-components';

export const Style = {
  RoleTabs: styled('div')(({ theme }) => css`
    display: flex;
    width: 100%;
    margin-bottom: ${theme.spacing.s6};
    gap: 0;
  `),
  RoleTab: styled('button')<{ $isActive: boolean }>(({ theme, $isActive }) => css`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacing.s2};
    border: none;
    padding: ${theme.spacing.s3} ${theme.spacing.s6};
    cursor: pointer;
    font-family: Noto Sans, 'Noto Sans SC', 'Poppins', sans-serif;
    font-size: 14px;
    line-height: 24px;
    font-weight: 600;
    background-color: ${$isActive ? theme.palette.P400 : theme.palette.N650};
    color: ${$isActive ? theme.palette.N700 : theme.palette.N350};
    border-radius: ${$isActive ? '8px' : '0'};

    &:hover {
      opacity: ${$isActive ? 1 : 0.9};
    }
  `)
};
